async function signup(username, email, password, token) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(token) && { "Authorization": "Bearer " + token }
        },
        body: JSON.stringify({ username, email, password }),
        mode: 'cors',
        cache: 'no-cache'
    };
    const response = await getResponse(`registration`, requestOptions);
    if (response.status === 403) {
        return {
            status: "duplicate"
        };
    }
    else {
        const data = await response.json();
        return {
            status: "processing",
            registrationID: data.registrationID
        };
    }
}

async function checkStatus(registrationID, token) {
    const requestOptions = {
        method: 'GET',
        headers: {
             'Content-Type': 'application/json',
            ...(token) && { "Authorization": "Bearer " + token }
             },
        mode: 'cors',
        cache: 'no-cache'
    };
    const response = await getResponse('registration/' + registrationID, requestOptions);
    if (response.status === 200) {
        const data = await response.json();
        return data;
    }
}

async function confirmationStatus(registrationID, confirmationID) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        cache: 'no-cache'
    };
    const response = await getResponse('registration/' + registrationID + '/confirmation/' + confirmationID + '/status', requestOptions);
    if (response.status === 200) {
        const data = await response.json();
        return data;
    }
}

async function getResponse(endpoint, reqHeaders) {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/` + endpoint, reqHeaders);
        if (res.ok || res.status === 403) {
            return res;
        }
        else {
            const errorData = await res.json();
            if (errorData.status === 503 && errorData.endTime) {
                throw new Error(`Graphologi is currently under maintenance.\nPlease try again after ${(new Date(errorData.endTime)).toLocaleString()}.`);
            }
            throw new Error("On endpoint: " + endpoint + " - " + errorData.message);
        }
    }
    catch (e) {
        if (e.message.startsWith("Graphologi")) throw e;
        throw new Error("Cannot get response from API call to: " + endpoint);
    }
}

export const registrationService = {
    signup,
    checkStatus,
    confirmationStatus
};
